import PageHero from "@/components/landing/PageHero";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { useSEO } from "@/hooks/useSEO";
import { customers } from "@/components/landing/solutions/data";

export default function Solutions() {
  useSEO({
    title: "Biopharma Solutions by Customer Type | Pharmalify Spine",
    description: "Explore Pharmalify Spine for emerging biotech, growth biopharma, multi-site mid-size organizations and CDMO/CRO teams.",
    canonical: "https://www.pharmalify.com/solutions",
  });
  return (
    <main className="min-h-screen bg-background">
      <PageHero title="Solutions for your stage of biopharma" description="Pharmalify Spine connects Quality (eQMS), QC Lab (LIMS) and Asset Integrity (CMMS) for small-to-mid organizations, up to hundreds of users across sites." />
      <section className="container py-16" aria-labelledby="customer-solutions">
        <h2 id="customer-solutions" className="text-3xl font-bold text-foreground mb-4">One backbone, shaped around your team</h2>
        <p className="text-muted-foreground max-w-3xl mb-10">Keep quality records connected as your people, programs and sites grow. AI Agents and Regulatory Watch are native capabilities inside Spine, not separate products.</p>
        <div className="grid gap-6 md:grid-cols-2">
          {customers.map(({ icon: Icon, title, description, scale, challenges, configuration, validation, rollout }) => (
            <article key={title} className="rounded-xl border border-border bg-card p-8">
              <Icon className="h-7 w-7 text-accent mb-4" aria-hidden="true" />
              <h3 className="text-xl font-semibold text-card-foreground mb-2">{title}</h3>
              <p className="text-sm font-medium text-accent mb-3">{scale}</p>
              <p className="text-muted-foreground leading-relaxed mb-5">{description}</p>
              <dl className="space-y-3 text-sm">
                {[["Typical challenge", challenges], ["Spine configuration", configuration], ["Validation scope", validation], ["Rollout", rollout]].map(([k, v]) => (
                  <div key={k}>
                    <dt className="font-semibold text-card-foreground">{k}</dt>
                    <dd className="text-muted-foreground leading-relaxed">{v}</dd>
                  </div>
                ))}
              </dl>
            </article>
          ))}
        </div>
      </section>
      <section className="bg-muted/30 py-16">
        <div className="container max-w-3xl text-center">
          <h2 className="text-3xl font-bold text-foreground mb-4">Discuss your next stage</h2>
          <p className="text-muted-foreground mb-8">Contract-based access, with scope and onboarding agreed for your organization. Explore the workflows that matter to your team in a private walkthrough.</p>
          <Button asChild><Link to="/contact">Request Walkthrough</Link></Button>
          <Link to="/spine" className="inline-block ml-6 text-accent underline">Explore Pharmalify Spine</Link>
        </div>
      </section>
    </main>
  );
}
